const styles = (theme) => ({
  listItemSelected: {
    backgroundColor: theme.palette.action.selected,
    borderLeft: `4px solid ${theme.palette.primary.main}`,
  },
});

export default styles;
